export default __webpack_public_path__ + "static/media/Dishes.7fecf78f.svg";